import styled from 'styled-components';
import { spacingHelper, typographyHelper, Button, mediaHelper } from '@property.com.au/ui-kit';

export const ShowMoreButton = styled(Button)<{
  $visibleOnMobile: boolean;
  $visibleOnDesktop: boolean;
}>`
  ${typographyHelper('overline')};
  margin: ${spacingHelper('large auto extraSmall')};

  ${mediaHelper('tabletMax')} {
    ${({ $visibleOnMobile }) => `display: ${$visibleOnMobile ? 'block' : 'none'}`};
  }

  ${mediaHelper('desktopMin')} {
    ${({ $visibleOnDesktop }) => `display: ${$visibleOnDesktop ? 'block' : 'none'}`};
  }
`;
